export default __webpack_public_path__ + "images/02ac6cdee8e7795fdc371ef49954f8c9.svg";